import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { animation, borderRadius, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';

export const MenuItemHeader = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${nafColor.signature.black};
  margin-bottom: ${spacing.space8};
  width: fit-content;

  span {
    color: ${nafColor.signature.black} !important;
    padding: ${spacing.space4} ${spacing.space8} ${spacing.space4} ${spacing.space8};
    font-size: 1.125rem;

    &:hover {
      text-decoration: none;
      background-color: ${nafColor.signature.yellow40};
      border-radius: ${borderRadius.L};
    }
  }

  svg {
    margin-left: ${spacing.space4};
    margin-bottom: ${spacing.space4};
    transition: ${animation.uiSpeed}ms ${animation.easeOut};
    color: ${nafColor.signature.black} !important;
  }

  &:hover svg {
    transform: translateX(${spacing.space8});
  }
`;
